import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { dsI18n, getCommonButtonTypeDefault, getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { Icon, ExternalIcon } from '@skatteetaten/ds-icons';
import { Spinner } from '@skatteetaten/ds-progress';
import './styles.css';


const getButtonVariantDefault = ()=>'primary';

var styles = {
    "button_danger": "Button-module_button_danger__yYmYD",
    "button_tertiary": "Button-module_button_tertiary__t-HDB",
    "button_secondary": "Button-module_button_secondary__67g8S",
    "button_primary": "Button-module_button_primary__LCCBW",
    "iconWrapper": "Button-module_iconWrapper__CbS5a",
    "icon": "Button-module_icon__UlmjN",
    "button": "Button-module_button__-iBP0",
    "button_withIcon": "Button-module_button_withIcon__kzVcO",
    "button_withIconRight": "Button-module_button_withIconRight__YzJ20",
    "iconExternal": "Button-module_iconExternal__pSSzu",
    "buttonText": "Button-module_buttonText__NQRYg",
    "hide": "Button-module_hide__9MRY5",
    "spinner": "Button-module_spinner__ZtUdc"
};

const Button = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, spinnerTitle, svgPath, variant = getButtonVariantDefault(), accessKey, disabled, form, href, type = getCommonButtonTypeDefault(), ariaDescribedby, ariaCurrent, hasSpinner, isExternal, onBlur, onClick, onFocus, children }, ref)=>{
    const { t } = useTranslation('ds_buttons', {
        i18n: dsI18n
    });
    const withIconClassName = !isExternal && svgPath ? styles.button_withIcon : '';
    const withIconRightClassName = isExternal ? styles.button_withIconRight : '';
    const concatenatedClassName = `${styles.button} ${styles[`button_${variant}`]} ${withIconClassName} ${withIconRightClassName} ${className}`.trim();
    const hideClassName = hasSpinner ? styles.hide : '';
    const getSpinnerColor = ()=>{
        if (disabled) {
            return 'black';
        } else if (variant === 'primary') {
            return 'white';
        } else if (variant === 'danger') {
            return 'black';
        } else {
            return 'blue';
        }
    };
    const Tag = href !== undefined ? 'a' : 'button';
    return /*#__PURE__*/ jsxs(Tag, {
        ref: ref,
        id: id,
        className: concatenatedClassName,
        lang: lang,
        "data-testid": dataTestId,
        accessKey: accessKey,
        disabled: disabled,
        href: href,
        form: form,
        type: href !== undefined ? undefined : type,
        "aria-current": ariaCurrent,
        "aria-describedby": ariaDescribedby,
        role: href ? 'button' : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        children: [
            !isExternal && svgPath && /*#__PURE__*/ jsx("span", {
                className: `${styles.iconWrapper} ${hideClassName}`.trim(),
                children: /*#__PURE__*/ jsx(Icon, {
                    className: styles.icon,
                    svgPath: svgPath
                })
            }),
            /*#__PURE__*/ jsx("span", {
                className: `${styles.buttonText} ${hideClassName}`.trim(),
                children: children
            }),
            isExternal && /*#__PURE__*/ jsx("span", {
                className: `${styles.iconWrapper} ${hideClassName}`.trim(),
                children: /*#__PURE__*/ jsx(ExternalIcon, {
                    className: `${styles.icon} ${styles.iconExternal} ${hideClassName}`.trim(),
                    ariaLabel: t('shared.ExternalIcon')
                })
            }),
            hasSpinner && /*#__PURE__*/ jsx(Spinner, {
                className: styles.spinner,
                color: getSpinnerColor(),
                size: 'small',
                hideTitle: true,
                children: spinnerTitle
            })
        ]
    });
});
Button.displayName = 'Button';

export { Button, getButtonVariantDefault };
